import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useId } from '@reach/auto-id';
import classnames from 'classnames2';
import React from 'react';
import { Icon } from '../Icon';
import { LoadingSpinner } from '../LoadingSpinner';
import { isSelectFooter } from './Select.Footer';
import { SelectList } from './Select.List';
import styles from './Select.scss';
import { SelectContextWrapper } from './SelectContextWrapper';
import { useSelectContext } from './useSelectContext';

var SelectButton = function SelectButton(props) {
  var _buttonSizeStyle;

  var _props$size = props.size,
      size = _props$size === void 0 ? 'Default' : _props$size;

  var _useSelectContext = useSelectContext(),
      isOpen = _useSelectContext.isOpen,
      menuId = _useSelectContext.menuId,
      buttonId = _useSelectContext.buttonId,
      buttonRef = _useSelectContext.buttonRef,
      hasParentMenu = _useSelectContext.hasParentMenu,
      onClose = _useSelectContext.onClose,
      openAndFocusMenu = _useSelectContext.openAndFocusMenu;

  var onClick = function onClick(event) {
    // Prevent this action if it's not top-level button
    if (hasParentMenu) {
      return;
    }

    if (isOpen) {
      onClose();
    }

    if (!isOpen) {
      openAndFocusMenu();
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      openAndFocusMenu();
    }
  };

  var buttonWidthStyle = function buttonWidthStyle() {
    switch (props.width) {
      case 'full':
        return styles.fullContainerWidth;

      case 'min':
        return null;

      default:
        return styles.defaultButtonWidth;
    }
  };

  var buttonSizeStyle = (_buttonSizeStyle = {}, _defineProperty(_buttonSizeStyle, styles.defaultButtonSize, size === 'Default'), _defineProperty(_buttonSizeStyle, styles.smallButtonSize, size === 'Small'), _buttonSizeStyle);
  var labelledbyId = "button-value-".concat(useId());
  return React.createElement("button", {
    "aria-labelledby": "".concat(labelledbyId, " ").concat(props.labelId),
    "aria-haspopup": "listbox",
    "aria-expanded": isOpen,
    "aria-controls": menuId,
    id: buttonId,
    ref: buttonRef,
    className: classnames(styles.button, buttonSizeStyle, buttonWidthStyle()),
    "data-test": props.dataTest,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    disabled: props.disabled || props.loading
  }, props.loading ? React.createElement(LoadingSpinner, {
    message: props.loadingText
  }) : React.createElement("span", {
    id: labelledbyId
  }, props.label), React.createElement(Icon, {
    icon: "arrow-caret-down",
    className: styles.caretIcon,
    ariaHidden: true
  }));
};

export var Select = function Select(props) {
  var containerStyle = function containerStyle() {
    switch (props.width) {
      case 'full':
        return styles.flexGrow;

      default:
        return null;
    }
  };

  var className = props.className,
      width = props.width,
      children = props.children,
      maxMenuHeight = props.maxMenuHeight;
  var withFooter = isSelectFooter(React.Children.toArray(children).pop());
  return React.createElement(SelectContextWrapper, {
    onChange: props.onChange,
    selectedValue: props.value
  }, React.createElement("div", {
    className: classnames(styles.flexContainer, className)
  }, React.createElement("div", {
    className: classnames(styles.container, containerStyle())
  }, React.createElement(SelectButton, {
    size: props.size,
    width: props.width,
    labelId: props.labelId,
    label: props.valueLabel || props.placeholder,
    dataTest: props.dataTest,
    disabled: props.disabled,
    loading: props.loading,
    loadingText: props.loadingText
  }), React.createElement(SelectList, {
    width: width,
    height: maxMenuHeight,
    hasFooter: withFooter
  }, props.children))));
};
Select.displayName = 'Select';